<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app">
    <nprogress-container></nprogress-container>
    <router-view></router-view>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  components: { NprogressContainer },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val);
    }
  },
  methods: {
    toggleClassInBody (className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
      }
    },
    handleWindowResize (event) {
      this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
    },
    loadDatabase () {
       this.$vs.loading({
        type: 'sound',
        text: 'Loading Database'
      })

      const collections = ['page', 'category', 'recommendationBusiness', 'banner', 'user', 'toplist']
      let promises = []

      collections.forEach(i => {
        promises.push(this.$store.dispatch(`${i}/openDBChannel`))
      })

      Promise.all(promises)
        .catch((err) => this.notifyError(err))
        .then(() => this.$vs.loading.close())
    }
  },
  mounted () {
    this.toggleClassInBody(themeConfig.theme)
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });
    this.$store.dispatch('updateWindowWidth', window.innerWidth);

    this.loadDatabase()

    firebase.auth().onAuthStateChanged(() => {
      const userData = firebase.auth().currentUser

      if (userData) this.$store.dispatch('auth/setUserData', {
        displayName: userData.displayName,
        email: userData.email,
        photoURL : userData.photoURL
      })
    })

  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize);
  },
}

</script>

<style lang="css">
  .nprogress-container {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 2px;
    z-index: 99999;
  }
</style>
